import { equipmentMedia } from 'functions/equipmentUtils'

export default function WorkoutV5EquipmentPreview({
    exerciseHashMap = {},
    workout = null
}) {

    const GetEquipmentKeysFromWorkout = (workout) => {
        var equipmentKeys = []

        workout.phases.map((phase) => {

            phase.slots.map((slot) => {

                const exercise = exerciseHashMap[slot.exerciseId]

                // Edge case for band and machine equipment. Only push band as required
                if (exercise.equipment === 'band,machine') {
                    if (!equipmentKeys.includes('band')) equipmentKeys.push('band')
                }

                // Edge case for dumbbell and kettlebell equipment. Only push dumbbell as required
                else if (exercise.equipment === 'dumbbell,kettlebell') {
                    if (!equipmentKeys.includes('dumbbell')) equipmentKeys.push('dumbbell')
                }

                // Edge case for band, dumbbell, and kettlebell equipment. Only push dumbbell as required
                else if (exercise.equipment === 'band,dumbbell,kettlebell') {
                    if (!equipmentKeys.includes('band')) equipmentKeys.push('band')
                    if (!equipmentKeys.includes('dumbbell')) equipmentKeys.push('dumbbell')

                } else {
                    var currentExerciseEquipment = exercise.equipment.split(',')

                    currentExerciseEquipment.map((equipment) => {
                        if (equipment.length > 0) {
                            if (!equipmentKeys.includes(equipment)) equipmentKeys.push(equipment)
                        }
                    })
                }
            })
        })

        return equipmentKeys
    }

    if (Object.keys(exerciseHashMap).length === 0 || workout === null) {
        return null
    }

    const equipmentKeys = GetEquipmentKeysFromWorkout(workout)

    if (equipmentKeys.length === 0) {
        return (
            <div className='px-4 py-2 flex items-center rounded-xl overflow-hidden text-center bg-white gap-x-2 shadow-md'>
                <p className="text-gray-500">No equipment required</p>
            </div>
        )
    }

    return (
        <div className='grid grid-cols-2 gap-4'>
            {equipmentKeys.map((equipment, index) => (
                <div
                    key={index}
                    className='px-4 py-2 flex items-center rounded-xl overflow-hidden text-center bg-white gap-x-2 shadow-md'
                >
                    <img
                        src={equipmentMedia[equipment].imageURL}
                        alt="Equipment Icon"
                        className="h-6 m-1"
                    />

                    <p className="text-gray-500">{equipmentMedia[equipment].name}</p>
                </div>
            ))}
        </div>
    )
}